@import 'styles/mixins';
@import 'styles/variables';

.defaultsPreview {
  left: -999999px;
  position: absolute;
  top: -999999px;
}

.container {
  margin: auto;
  max-width: 1178px;

  .previewWrapper {
    display: flex;
    justify-content: center;

    .articleStyle {
      flex-basis: 360px;
      flex-grow: 0;
      flex-shrink: 0;

      > header {
        display: flex;
        margin-bottom: 16px;
        padding: 16px;

        a,
        .cancelButton {
          color: $gray-40;
        }

        a,
        button {
          @include btn-md-text;

          align-items: center;
          display: flex;
          justify-content: center;
          margin-right: 8px;
          min-width: 96px;
        }
      }
    }

    .previewContainer {
      @include shadow-3;

      border-radius: 16px;
      margin-right: 18px;
      max-width: 800px;
      padding: 32px;

      .previewHint {
        @include header-label;

        color: $gray-40;
        margin-bottom: 48px;
        padding: 4px 0;
      }
    }
  }
}

.resetButton {
  @include btn-md-text;

  background-color: $gray-10;
  border-radius: 4px;
  color: $almanac-black;
  display: block;
  margin: auto;
  padding: 10px;
}
